// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__38Ust","savePackageButton":"ClientWallet_savePackageButton__1Y2Mo"};